import { BaseEdge, type Edge, type EdgeProps, getSmoothStepPath } from "@xyflow/react"

type CustomEdge = Edge<{ value: number }, "custom">

const SegmentEdge = ({
  id,
  targetX,
  targetY,
  sourceX,
  sourceY,
  sourcePosition,
  targetPosition
}: EdgeProps<CustomEdge>) => {
  const [edgePath] = getSmoothStepPath({
    borderRadius: 16,
    offset: 0,
    sourcePosition,
    sourceX,
    sourceY,
    targetPosition,
    targetX,
    targetY
  })

  const lineStyle = {
    stroke: "var(--color-blue-300)",
    strokeWidth: 2,
    zIndex: 10
  }

  return <BaseEdge id={id} path={edgePath} style={lineStyle} />
}

export default SegmentEdge
